import { render, staticRenderFns } from "./TemplateSubmissionInfo.vue?vue&type=template&id=570ee636&scoped=true&"
import script from "./TemplateSubmissionInfo.vue?vue&type=script&lang=ts&"
export * from "./TemplateSubmissionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateSubmissionInfo.vue?vue&type=style&index=0&id=570ee636&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570ee636",
  null
  
)

export default component.exports